import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagZA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M7.323 42.678c-9.763-9.763-9.763-25.592 0-35.356L21.74 25 7.323 42.678Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M21.74 25 3.317 12.55a24.912 24.912 0 0 0-1.508 3.101L11.136 25l-9.327 9.348a24.882 24.882 0 0 0 1.507 3.1L21.74 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M49.788 21.74h-28.05L7.32 7.322a25.097 25.097 0 0 0-4.006 5.227L15.74 25 3.314 37.45a25.094 25.094 0 0 0 4.007 5.229L21.738 28.26h28.05a25.241 25.241 0 0 0 0-6.522Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M9.78 44.831A24.889 24.889 0 0 0 25 50c11.551 0 21.27-7.834 24.14-18.478H23.09L9.78 44.831Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M49.14 18.478C46.27 7.834 36.55 0 25 0A24.889 24.889 0 0 0 9.78 5.168l13.31 13.31h26.05Z"
}));
FlagZA.displayName = 'FlagZA';
export default withFlagWrapper(FlagZA);
//# sourceMappingURL=index.js.map